import { useEffect, useState } from "react";

export default function QuickActionEditClientModal({ open, loading, client, onClose, onSubmit }) {
  const [form, setForm] = useState({
    naam: "",
    email: "",
    telefoon: "",
    adres: "",
    postcode: "",
    plaats: "",
    kvkNummer: "",
    btwNummer: "",
  });

  useEffect(() => {
    if (!open || !client) return;
    setForm({
      naam: client.naam || "",
      email: client.email || "",
      telefoon: client.telefoon || "",
      adres: client.adres || "",
      postcode: client.postcode || "",
      plaats: client.plaats || "",
      kvkNummer: client.kvkNummer || "",
      btwNummer: client.btwNummer || "",
    });
  }, [client, open]);

  if (!open) return null;

  const update = (field, value) => setForm((prev) => ({ ...prev, [field]: value }));

  const handleSubmit = async (event) => {
    event.preventDefault();
    await onSubmit(form);
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 p-4">
      <div className="w-full max-w-2xl rounded-2xl border border-slate-200 bg-white p-5 shadow-xl">
        <h3 className="text-lg font-semibold text-slate-900">Klant bewerken</h3>

        <form onSubmit={handleSubmit} className="mt-4 grid gap-3 md:grid-cols-2">
          <input className="rounded-lg border border-slate-200 px-3 py-2" placeholder="Bedrijfsnaam" value={form.naam} onChange={(e) => update("naam", e.target.value)} required />
          <input className="rounded-lg border border-slate-200 px-3 py-2" placeholder="E-mail" value={form.email} onChange={(e) => update("email", e.target.value)} />
          <input className="rounded-lg border border-slate-200 px-3 py-2" placeholder="Telefoon" value={form.telefoon} onChange={(e) => update("telefoon", e.target.value)} />
          <input className="rounded-lg border border-slate-200 px-3 py-2" placeholder="Adres" value={form.adres} onChange={(e) => update("adres", e.target.value)} />
          <input className="rounded-lg border border-slate-200 px-3 py-2" placeholder="Postcode" value={form.postcode} onChange={(e) => update("postcode", e.target.value)} />
          <input className="rounded-lg border border-slate-200 px-3 py-2" placeholder="Plaats" value={form.plaats} onChange={(e) => update("plaats", e.target.value)} />
          <input className="rounded-lg border border-slate-200 px-3 py-2" placeholder="KVK-nummer" value={form.kvkNummer} onChange={(e) => update("kvkNummer", e.target.value)} />
          <input className="rounded-lg border border-slate-200 px-3 py-2" placeholder="BTW-nummer" value={form.btwNummer} onChange={(e) => update("btwNummer", e.target.value)} />

          <div className="col-span-full flex justify-end gap-2 pt-1">
            <button type="button" onClick={onClose} className="rounded-lg border border-slate-200 px-4 py-2 text-sm" disabled={loading}>
              Annuleren
            </button>
            <button type="submit" className="rounded-lg bg-slate-900 px-4 py-2 text-sm text-white" disabled={loading}>
              {loading ? "Opslaan..." : "Opslaan"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
